import React, { SVGProps } from 'react';

export const Info = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M13.058 6.44c.273.262.443.63.443 1.038v.03-.002.021c0 .407-.17.773-.443 1.034a1.45 1.45 0 0 1-1.058.44 1.46 1.46 0 0 1-1.052-.44 1.42 1.42 0 0 1-.449-1.038v-.03c0-.276.078-.534.212-.753l-.003.006c.134-.224.32-.41.543-.544.21-.127.464-.202.736-.202H12q.617 0 1.057.44M11.1 17.25h1.8v-6h-1.8zm12.3-5.272c0 2.253-.478 4.262-1.417 5.968a10.2 10.2 0 0 1-3.964 4.004l-.052.027c-1.702.944-3.712 1.423-5.968 1.423s-4.263-.478-5.965-1.423a10.23 10.23 0 0 1-3.992-3.98l-.026-.05c-.94-1.71-1.417-3.716-1.417-5.969 0-2.241.476-4.242 1.417-5.94A10.23 10.23 0 0 1 5.982 2.05l.052-.026C7.736 1.079 9.744.6 11.999.6s4.265.479 5.966 1.424a10.24 10.24 0 0 1 3.991 3.962l.027.052c.94 1.698 1.417 3.697 1.417 5.941m-1.8.002c0-1.936-.402-3.64-1.193-5.069a8.44 8.44 0 0 0-3.271-3.294l-.043-.021C15.662 2.802 13.948 2.4 12.001 2.4s-3.66.402-5.093 1.196a8.44 8.44 0 0 0-3.292 3.273l-.022.042c-.79 1.43-1.192 3.135-1.192 5.07 0 1.943.402 3.658 1.194 5.097a8.45 8.45 0 0 0 3.273 3.306l.042.021c1.43.794 3.144 1.196 5.09 1.196 1.947 0 3.66-.402 5.093-1.196a8.45 8.45 0 0 0 3.293-3.287l.021-.043c.79-1.436 1.193-3.15 1.193-5.095z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
